export const MAX_LENGTH_FOLDER_FILE_NAME = 100

const MAX_LENGTH = {
  COMMON: 255,
  PASSWORD: 32,
  _1: 1,
  _4: 4,
  _10: 10,
  _12: 12,
  _16: 16,
  _20: 20,
  _50: 50,
  _100: 100,
  _500: 500,
  NUMBER_MAX_LIMIT: 9999999999, // 9,999,999,999
  MAX_INT_LIMIT: 999999999, // 999, 999, 999
  COST_REDUCTION: 50,
  MAX_NUMBER_CHARS: 10,
  ZERO: 0,
}

export { MAX_LENGTH }
